import $ from 'jquery';
import hoverintent from 'hoverintent';

export default class Menu {
  constructor(theme, element) {
    const self = this;
    this.theme = theme;
    this.element = element;
    this.$element = $(element);

    this.$nav = $('#AccessibleNav');
    this.$allLinks = this.$nav.find('a');
    this.$topLevel = this.$nav.children('li').find('a');
    this.$parents = this.$nav.find('.site-nav--has-dropdown');
    this.$subMenuLinks = this.$nav.find('.site-nav__dropdown').find('a');
    this.activeClass = 'nav-hover';
    this.focusClass = 'nav-focus';

    this.$parents.on('mouseover touchstart', function(evt) {
      var ret = true;
      var $el = $(this);

      if (!$el.hasClass(self.activeClass)) {
        evt.preventDefault();
        ret = false;
      }

      self.showDropdown($el);
      return ret;
    });

    this.$parents.each(
      (i, el) => {
        hoverintent(
          el,
          function(evt) {
            $('.' + self.activeClass).each(function (el) {
              var $active = $(this);
              if ($active.has(evt.target).length === 0) {
                $active.removeClass(self.activeClass);
              }
            });
          },
          function() {
          }
        );
      }
    );

    // Mouseout
    $('.site-header').on('mouseleave', () => {
      this.hideDropdown();
    });

    this.$subMenuLinks.on('touchstart', function(evt) {
      // Prevent touchstart on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    this.$allLinks.focus(function() {
      self.handleFocus($(this));
    });

    this.$allLinks.blur(() => {
      self.removeFocus(self.$topLevel);
    });
  }

  // accessibleNav private methods
  handleFocus = ($el) => {
    const isSubItem = $('.site-nav__dropdown').has($el).length > 0;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      this.removeFocus(this.$topLevel);
      this.addFocus($el);
    } else {
      this.addFocus($el.closest('.site-nav--has-dropdown').find('a'));
    }
  }

  showDropdown = ($el) => {
    $el.addClass(this.activeClass);

    // Remove iOS workaround because it breaks menu z-index
    $('.sticky-header').removeClass('sticky-header-transformed');

    // Select if the submenu should appear left or right of the menu
    var $child = $el.parent().find('.site-nav__subdropdown');
    var childWidth = Math.max.apply(null, $child.map(function () { return $(this).width() }).get());
    var right = $el.offset().left + $el.outerWidth() + childWidth;
    if (right > $('body').width()) {
      $child.css({
        right: '100%',
        left: 'auto'
      });
    } else {
      $child.css({
        left: '100%',
        right: 'auto'
      });
    }

    setTimeout(function() {
      $(document.body).on('touchstart', (evt) => {
        if ($(evt.target).closest('.site-nav__link,.dropdown-submenu').length === 0) {
          // Hide dropdown if the touchstart was not on nav link
          this.hideDropdown($el);
        }
      });
    }, 250);
  }

  hideDropdown = ($el) => {
    if ($el !== undefined) $el.removeClass(this.activeClass);
    else $('.site-nav--has-dropdown').removeClass(this.activeClass);
    $(document.body).off('touchstart');

    // Reenable iOS workaround
    if ($('.nav-hover').length === 0) {
      $('.sticky-header').addClass('sticky-header-transformed');
    }
  }

  addFocus = ($el) => {
    $el.addClass(this.focusClass);
  }

  removeFocus = ($el) => {
    $el.removeClass(this.focusClass);
  }
}
